import React, {useState, useEffect, Fragment} from 'react';
import { get } from '../../Services/http';
import { translate } from '../../Services/translation';
import { boldSubstr } from '../QuickSearchResult';
import { getAddressCombinedString, filterStoresBasedOnInput } from '../../Services/StoreService';

const MyDetailsPanelStores = props => {
    const [stores, setStores] = useState([]);
    const [selectedStoreName, setSelectedStoreName] = useState("");
    const [showStoresList, setshowStoresList] = useState(false);
    const [filteredStores, setfilteredStores] = useState([]);
    const [noresults, setnoresults] = useState(false);
    const [searchTerm, setsearchTerm] = useState("");
    const [selectedStoreId, setselectedStoreId] = useState("");
    const [storeChangeEffect, setStoreChangeEffect] = useState({oldPricePerMonth: '', newPricePerMonth: '', hasPriceChanged: false, newClinicalPartPrice: 0});
    const toggleShowStoresList = () => {
      setshowStoresList(!showStoresList);
      setsearchTerm("");
      setfilteredStores(stores);
    };

    useEffect(() => {      
        get(`/api/stores/GetNearestStores`)
        .then((response) => response.json())
        .then((result) => {
            const sortedResults = result.sort((a, b) => a.storeName.localeCompare(b.storeName));
            setStores(sortedResults);
            setfilteredStores(sortedResults);            
            if (props.selectedStore) {
              setselectedStoreId(props.selectedStore);
              setSelectedStoreName(result.filter(a => a.storeId === props.selectedStore)[0].storeName);              
            }            
        });        
      }, []); 
        
      let resetClicked = document.getElementById('resethdn');
        resetClicked.addEventListener("change", function (event) {        
        if (event.target.value === "true") {          
          if (stores && stores.length > 0) {
            setselectedStoreId(props.selectedStore);
            setSelectedStoreName(stores.filter(a => a.storeId === props.selectedStore)[0].storeName);
          }  
        }
      });
    
    useEffect(() => {
      if (props.hasSubscriptionAndClinicalPartActive == 'True' && selectedStoreId !== "") {
        document.getElementById("mydetails-button").disabled = true;
        get(`/api/customer/checkifstorechangeeffectssubscriptionprice/${props.customerId}/${selectedStoreId}`)
        .then((response) => response.json())
        .then((result => {
          setStoreChangeEffect(result);
          document.getElementById("mydetails-button").disabled = false;
        }))
      }
    }, [selectedStoreId])

      const filterStores = (input) => {
        setsearchTerm(input);
        const storesFiltered = filterStoresBasedOnInput(stores, input);

        if (storesFiltered && storesFiltered.length > 0) {
          setfilteredStores(storesFiltered);
        } else {
          setfilteredStores([]);
          setnoresults(true);
        }        
      }
      
      const handleClickOutside = (event) => {                
        if (!event.target.classList.contains("mydetails-panel__search") && !event.target.classList.contains("mydetails-panel__search-icon")
        && !event.target.classList.contains("mydetails-stores")) {                   
          const dropdown = document.getElementById('mydetails-stores');
          if (dropdown && !dropdown.contains(event.target)) {      
            setshowStoresList(false);                                                  
          }
        }        
      };

      useEffect(() => {
          document.addEventListener('click', function (e) {
          if (!e.target.classList.contains("mydetails-panel__search") && !e.target.classList.contains("mydetails-panel__search-icon")) {
            handleClickOutside(e);
          }          
        });        
      }, []); 

      return(
        <Fragment>     
            <div className="columns small-12 medium-6 mydetails-panel__column">
                <input type="hidden" id="NearestOptician" name="NearestOptician" value={selectedStoreId}></input>
                <input type="hidden" id="HasPriceChanged" name="HasPriceChanged" value={storeChangeEffect.hasPriceChanged}></input>
                <input type="hidden" id="NewClinicalPartPrice" name="NewClinicalPartPrice" value={storeChangeEffect.newClinicalPartPrice}></input>
                  <label className="form__label">{translate('coptikk.mypage.person.neareststore')}</label>                  
                    <div id="mydetails-stores" className={`mydetails-panel__store-name ${props.validModelState !== "False" ? ' mydetails-panel__disabledinput' : ' ' }`}>
                        <a onClick={() => toggleShowStoresList()}>{selectedStoreName}
                          <span></span>
                        </a>  
                    </div>                                        
                  {showStoresList && 
                  <div className="mydetails-panel__results">
                      <input className="mydetails-panel__search" onChange={e => filterStores(e.target.value)} 
                      placeholder={translate('coptikk.mypages.searchplaceholder')} value={searchTerm}></input>
                      <i className="mydetails-panel__search-icon"></i>
                      {filteredStores.map(x => {
                          return <div className="mydetails-panel__results-item" onClick={() =>  {
                            setselectedStoreId(x.storeId);
                            setshowStoresList();
                            setSelectedStoreName(stores.filter(a => a.storeId === x.storeId)[0].storeName);
                            setsearchTerm("");
                            setfilteredStores(stores);
                          }}>
                              <div dangerouslySetInnerHTML={{ __html: searchTerm ? boldSubstr(x.storeName, searchTerm) : x.storeName}}></div>
                                <div dangerouslySetInnerHTML={{ __html: searchTerm ? boldSubstr((getAddressCombinedString(x)), searchTerm) : 
                                  getAddressCombinedString(x)}}>
                                 </div>
                            </div>
                      })}
                      {noresults && <div>{translate('coptikk.mypages.searchnoresults')}</div>}
                  </div>} 
            </div>                                      
            {storeChangeEffect.hasPriceChanged && 
            <>
              <div className='mydetails-panel__updated-info'>
                <div className='left-column'>
                  <div className='icon'>i</div>
                </div>
                <div className='right-column'>
                  <p className='description'>{translate('coptikk.mypage.changeeffect.description').replace('{shopname}', selectedStoreName)}</p>
                  <div className='old-price'>
                    <p className='bold'>{translate('coptikk.mypage.changeeffect.oldprice')}: </p>
                    <p>{storeChangeEffect.oldPricePerMonth} / {translate('coptikk.checkout.cart.month')}</p>
                  </div>
                  <div className='new-price'>
                    <p className='bold'>{translate('coptikk.mypage.changeeffect.newprice')}: </p>
                    <p>{storeChangeEffect.newPricePerMonth} / {translate('coptikk.checkout.cart.month')}</p>
                  </div>
                </div>
              </div>
            </>
            }  
        </Fragment>
      )
}

export default MyDetailsPanelStores;